
import { Vue, Component } from 'vue-property-decorator';
import { getDetail } from '../api';
import XGplayer from '@/components/XGplayer.vue';
import { Swipe, SwipeItem, Lazyload, ImagePreview } from 'vant';
Vue.use(Swipe)
  .use(SwipeItem)
  .use(Lazyload);
  @Component({
  components: {
    XGplayer
  },
})
export default class Detail extends Vue {
  obj: any = {};
  async activated() {
    const res: any = await getDetail(this.$route.query.id);
    this.obj = res.data;
  }
  back(){
    this.$router.go(-1);
  }
  goUrl(url: any) {
    window.location.href = url;
  }

  getImg(imageList: any, index: number) {
    const scroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    ImagePreview({
      images: imageList, // 预览图片的那个数组
      showIndex: true,
      loop: false,
      startPosition: index, // 指明预览第几张图
      onClose() {
        document.documentElement.scrollTop = scroll;
        document.body.scrollTop = scroll;
      },
    });
  }
}
